import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/checks`, {params: {...filters}})
  },

  indexCmc7(cmc7) {
    return Http.get(`/cmc7_checks`, {params: {cmc7}})
  },

  show(id) {
    return Http.get(`/checks/${id}`);
  },
  
  create(check){
    return Http.post(`/checks`, {check: {...check}})
  },

  update(check){
    return Http.put(`/checks/${check.id}`, {
      check: {...check},
    });
  },
  updateWithFormData(check){
    return Http.put(`/checks/${check.get('check[id]')}`, check);
  },

}
